import styled, {css} from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";
import {IJackpotBetWidgetBgBoxProps} from "./jackpot-bet-widget-bg.box";

export const JackpotBetWidgetBgDefaultBox = styled.div<IJackpotBetWidgetBgBoxProps>`
  
  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    background-size: 220%;
  }
  
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    background-size: 210%;
  }
  
  background-image:
          url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_circle_svg.toString()}),
          linear-gradient(175.08deg, #9747FF 3.9%, #22004D 95.98%);
  background-size: 190%;
  background-repeat: no-repeat, no-repeat;
  background-position-y: 70%;
  background-position-x: 48%;

  background-blend-mode: hard-light;
  
  box-shadow: 0px 0px 10px 2px rgba(131, 255, 0, 0.75) inset;
  border-radius: 10px;

  width: 100%;

  display: flex;
  flex-direction: column;

  
  ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        flex-direction: row;
        align-items: center;
    `}

  overflow: visible;
  clip-path: inset(-9999px -9999px 0px -9999px);
  /* for older WebKit browsers: */
  -webkit-clip-path: inset(-9999px -9999px 0px -9999px);
`;
